// Mobile view toggle functionality for product grid
class MobileViewToggle {
  static instance = null;

  constructor() {
    // Singleton pattern to prevent multiple instances
    if (MobileViewToggle.instance) {
      MobileViewToggle.instance.refresh();
      return MobileViewToggle.instance;
    }

    MobileViewToggle.instance = this;
    this.init();
  }

  init() {
    this.refresh();
    this.setupObserver();
  }

  refresh() {
    // Re-query DOM elements
    this.productGrid = document.getElementById('product-grid');
    this.viewToggleButtons = document.querySelectorAll('.mobile-view-toggle__btn');

    if (!this.productGrid || !this.viewToggleButtons.length) return;

    // Remove old event listeners by cloning buttons
    this.viewToggleButtons.forEach((button) => {
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);
    });

    // Re-query after cloning
    this.viewToggleButtons = document.querySelectorAll('.mobile-view-toggle__btn');

    // Load saved view from localStorage
    const savedView = localStorage.getItem('mobileProductView') || 'grid';
    this.applyView(savedView);

    // Add click event listeners
    this.viewToggleButtons.forEach(button => {
      button.addEventListener('click', () => this.handleToggle(button));
    });
  }

  handleToggle(button) {
    const view = button.dataset.view;
    this.applyView(view);
    localStorage.setItem('mobileProductView', view);
  }

  applyView(view) {
    if (!this.productGrid) return;

    // Update button states
    this.viewToggleButtons.forEach(btn => {
      btn.classList.toggle('active', btn.dataset.view === view);
    });

    // Update grid data attribute
    this.productGrid.setAttribute('data-mobile-view', view);

    // Toggle grid classes
    if (view === 'list') {
      this.productGrid.classList.remove('grid--2-col-tablet-down');
      this.productGrid.classList.add('grid--1-col-tablet-down');
    } else {
      this.productGrid.classList.remove('grid--1-col-tablet-down');
      this.productGrid.classList.add('grid--2-col-tablet-down');
    }
  }

  setupObserver() {
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (!productGridContainer) return;

    // Only set up observer once
    if (this.observer) return;

    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Re-initialize after a short delay to ensure DOM is ready
          setTimeout(() => this.refresh(), 100);
        }
      });
    });

    this.observer.observe(productGridContainer, {
      childList: true,
      subtree: false
    });
  }
}

// Initialize on DOM load
document.addEventListener('DOMContentLoaded', () => {
  new MobileViewToggle();
});
